import { Platform } from 'react-native'

interface ThemeColors {
    textPrimary: string
    textSecondary: string
    colorPrimary: string
    colorSecondary: string
    colorTertiary: string
    colorApprovedEvaluation: string
    colorApproved: string
    colorCancelled: string
    colorPending: string
    colorInProgress: string
    colorLocked: string
    colorSeen: string
    colorRetry: string
    colorDisapproved: string
    error: string
    alert: string
    disabled: string
    background: string
    modalBackground: string
    formsBackground: string
    filtersBackground: string
    linearGradientStart: string
    linearGradientEnd: string
    linearGradientGreenStart: string
    linearGradientGreenEnd: string
    linearGradientRedStart: string
    linearGradientRedEnd: string
    neutralGray: string
    lightGray: string
    mediumGray: string
    darkGray: string
    colorHeart: string
    colorComment: string
    colorShare: string
    gamificationDotApprovedColor: string
    pageIndicatorBackground: string
    RankingFirstPlaceColor: string
    RankingSecondPlaceColor: string
    RankingThirdPlaceColor: string
    RankingPointsColor: string
    createScheduleBackgroundColor: string
    vacationDaySelectedColor: string
    floatPageIndicatorBackground: string
    storeFormButtonBackground: string
    storeItemTextAddressStoreWithGoTo: string
}

interface ThemeFontSizes {
    ultraBigText: number
    bigText: number
    normalText: number
    mediumText: number
    smallText: number
    ultraSmallText: number
}

interface ThemeFonts {
    main: string
}

interface ThemeFontWeights {
    light: string
    normal: string
    bold: string
}

interface ThemeFontStyles {
    normal: string
    italic: string
}

interface Theme {
    colors: ThemeColors
    fontSizes: ThemeFontSizes
    fonts: ThemeFonts
    fontWeights: ThemeFontWeights
    fontStyles: ThemeFontStyles
}

const theme: Theme = {
    colors: {
        textPrimary: '#0E0E2C',
        textSecondary: '#727293',
        colorPrimary: '#4891FE',
        colorSecondary: '#FFE055',
        colorTertiary: '#DB30A2',
        colorApprovedEvaluation: '#009E4D',
        colorApproved: '#009E4D',
        colorCancelled: '#E51D0D',
        colorPending: '#95919F',
        colorInProgress: '#FFA500',
        colorLocked: '#727293',
        colorSeen: '#FFE055',
        colorRetry: '#E51D0D',
        colorDisapproved: '#E51D0D',
        error: '#E51D0D',
        alert: '#FFDE39',
        disabled: '#DDDBE2',
        background: '#FFFFFF',
        modalBackground: '#F9FAFE',
        formsBackground: '#F2F1F8',
        filtersBackground: '#F2F1F8',
        linearGradientStart: '#113EDC',
        linearGradientEnd: '#0D96F2',
        linearGradientGreenStart: '#16823F',
        linearGradientGreenEnd: '#028754',
        linearGradientRedStart: '#C21818',
        linearGradientRedEnd: '#DA2121',
        neutralGray: '#DADADA',
        lightGray: '#CBCDE4',
        mediumGray: '#95919F',
        darkGray: '#5C5C86',
        colorHeart: '#E51D0D',
        colorComment: '#FFE055',
        colorShare: '#09B348',
        gamificationDotApprovedColor: '#53D06F',
        pageIndicatorBackground: '#FAFAFA',
        RankingFirstPlaceColor: '#E2BA61',
        RankingSecondPlaceColor: '#666666',
        RankingThirdPlaceColor: '#ED713B',
        RankingPointsColor: '#1C98F0',
        createScheduleBackgroundColor: '#E53935',
        vacationDaySelectedColor: '#141319',
        floatPageIndicatorBackground: '#FAFAFA',
        storeFormButtonBackground: '#F1F2FF',
        storeItemTextAddressStoreWithGoTo: '#6D85DA',
    },
    fontSizes: {
        ultraBigText: 18,
        bigText: 16,
        normalText: 15,
        mediumText: 14,
        smallText: 13,
        ultraSmallText: 12,
    },
    fonts: {
        main: Platform.select({
            android: 'System',
            ios: 'System',
            default: 'System',
        }) as string,
    },
    fontWeights: {
        light: '300',
        normal: '400',
        bold: '700',
    },
    fontStyles: {
        normal: 'normal',
        italic: 'italic',
    },
}

export default theme
export type { Theme, ThemeColors, ThemeFontSizes, ThemeFonts, ThemeFontWeights, ThemeFontStyles }
